import React from 'react';

/**
 * DesktopLayout Component
 *
 * Three-column desktop layout: left sidebar, main content, right sidebar.
 * Uses flexbox for responsive layout.
 */
const DesktopLayout = ({ leftSidebar, mainContent, rightSidebar }) => {
  return (
    <div className="desktop-layout" style={{
      display: 'flex',
      height: '100vh',
      overflow: 'hidden'
    }}>
      {leftSidebar}
      {mainContent}
      {rightSidebar}
    </div>
  );
};

export default DesktopLayout;
